export default "__VITE_ASSET__$9Yi5SxQ__"